import React from "react";

const ShareIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clipPath3472201590">
          <path
            d="M0 0L30 0L30 30L0 30L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath3472201590)">
        <path
          d="M3.125 5.25Q4.00519 5.25 4.62759 4.62759Q5.25 4.00519 5.25 3.125Q5.25 2.2448 4.6276 1.6224Q4.00519 1 3.125 1Q2.2448 1 1.6224 1.6224Q1 2.2448 1 3.125Q1 4.00519 1.6224 4.62759Q2.24481 5.25 3.125 5.25ZM3.125 7.25Q2.28644 7.25 1.51906 6.92542Q0.778622 6.61224 0.20819 6.04181Q-0.36224 5.47138 -0.675423 4.73094Q-1 3.96356 -1 3.125Q-1 2.28643 -0.675423 1.51905Q-0.362241 0.778615 0.208191 0.208184Q0.778622 -0.362245 1.51906 -0.675426Q2.28644 -1 3.125 -1Q3.96356 -1 4.73094 -0.675426Q5.47138 -0.362245 6.04181 0.208184Q6.61224 0.778615 6.92542 1.51905Q7.25 2.28643 7.25 3.125Q7.25 3.96356 6.92542 4.73094Q6.61224 5.47138 6.04181 6.04181Q5.47138 6.61224 4.73094 6.92542Q3.96356 7.25 3.125 7.25Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 18.75 3.75)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M3.125 5.25Q4.00519 5.25 4.62759 4.62759Q5.25 4.00519 5.25 3.125Q5.25 2.24481 4.62759 1.6224Q4.00519 1 3.125 1Q2.24481 1 1.6224 1.6224Q1 2.24481 1 3.125Q1 4.00519 1.6224 4.62759Q2.24481 5.25 3.125 5.25ZM3.125 7.25Q2.28644 7.25 1.51906 6.92542Q0.778622 6.61224 0.20819 6.04181Q-0.362241 5.47138 -0.675423 4.73094Q-1 3.96356 -1 3.125Q-1 2.28644 -0.675423 1.51906Q-0.362241 0.778621 0.20819 0.20819Q0.77862 -0.362241 1.51906 -0.675423Q2.28644 -1 3.125 -1Q3.96356 -1 4.73094 -0.675423Q5.47138 -0.362241 6.04181 0.20819Q6.61224 0.778622 6.92542 1.51906Q7.25 2.28644 7.25 3.125Q7.25 3.96356 6.92542 4.73094Q6.61224 5.47138 6.04181 6.04181Q5.47138 6.61224 4.73094 6.92542Q3.96356 7.25 3.125 7.25Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 5.0002 11.875)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M8.76846 -0.518179C8.48228 -0.990528 7.86736 -1.14145 7.39501 -0.855272L-0.518178 3.93904C-0.990528 4.22522 -1.14145 4.84014 -0.855272 5.31249C-0.569093 5.78484 0.0458286 5.93576 0.518179 5.64958L8.43137 0.855272C8.90371 0.569093 9.05464 -0.0458288 8.76846 -0.518179Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 10.8372 8.48403)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M-0.860926 -0.508731C-1.14189 -0.033259 -0.984203 0.579964 -0.508731 0.860926L7.82902 5.7878C8.30449 6.06876 8.91771 5.91108 9.19867 5.4356C9.47964 4.96013 9.32195 4.34691 8.84648 4.06595L0.508731 -0.860925C0.033259 -1.14189 -0.579964 -0.984203 -0.860926 -0.508731Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 10.8365 16.6024)"
          fill="rgb(255, 255, 255)"
        />
        <path
          d="M3.125 -1Q3.96356 -1 4.73094 -0.675423Q5.47138 -0.362241 6.04181 0.20819Q6.61224 0.778621 6.92542 1.51906Q7.25 2.28644 7.25 3.125Q7.25 3.96356 6.92542 4.73094Q6.61224 5.47138 6.04181 6.04181Q5.47138 6.61224 4.73094 6.92542Q3.96356 7.25 3.125 7.25Q2.28644 7.25 1.51906 6.92542Q0.778621 6.61224 0.20819 6.04181Q-0.362241 5.47138 -0.675423 4.73094Q-1 3.96356 -1 3.125Q-1 2.28644 -0.675423 1.51906Q-0.362241 0.778621 0.20819 0.20819Q0.778621 -0.362241 1.51906 -0.675423Q2.28644 -1 3.125 -1ZM3.125 1Q2.24481 1 1.6224 1.6224Q1 2.24481 1 3.125Q1 4.00519 1.6224 4.62759Q2.24481 5.25 3.125 5.25Q4.00519 5.25 4.62759 4.62759Q5.25 4.00519 5.25 3.125Q5.25 2.24481 4.62759 1.6224Q4.00519 1 3.125 1Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 18.75 20)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default ShareIcon;
